/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { getDelayAnalysisRoomData } from "../multiplayer/SocketConnection";
import { DELAY_ANALISYS_ROOM } from "../rooms/RoomNameConstants";
import { setCenterGraph } from "../store/slice/centerGraphSlice";
import { changeRoomHandler } from "./ChangeRoomHandlers";
import { setJobstream } from "../store/slice/roomSlices/delayAnalysisRoomSlice";
import store from "../store/store";

const delayAnalysisRoomSetup = (dispatch, selectedJob) => {
    getDelayAnalysisRoomData({
        selectedJob,
        targetRoom: DELAY_ANALISYS_ROOM
    })

    dispatch(setJobstream(selectedJob.jobstreamID));
}

export const handleGoToDelayAnalysisRoom = (selectedJob) => {
    const state = store.getState()
    const dispatch = store.dispatch

    const dataToCache = {
        key: "centerGraph",
        data: state.centerGraph,
        callback: (cachedData) => {
            dispatch(setCenterGraph(cachedData))
        },
    }

    changeRoomHandler(
        DELAY_ANALISYS_ROOM,
        delayAnalysisRoomSetup(dispatch, selectedJob),
        dataToCache
    )
}